document.addEventListener('change', function (event) {
    const select = event.target.closest('[data-upsell-variant-select]');

    if (!select) return;

    const upsell = select.closest('.product-upsell');
    const form = select.closest('.product-upsell__form--variants');
    const option = select.options[select.selectedIndex];

    if (!upsell || !form || !option) return;

    const newPrice = upsell.querySelector('.product-upsell__price .new-price');
    const oldPrice = upsell.querySelector('.product-upsell__price .old-price');
    const button = form.querySelector('[data-add-to-cart]');
    const buttonText = button?.querySelector('.btn__text');
    const image = upsell.querySelector('.product-upsell__image img');

    const price = option.dataset.price || '';
    const comparePrice = option.dataset.comparePrice || '';
    const available = option.dataset.available === 'true';
    const imageUrl = option.dataset.image || '';

    if (newPrice) {
      newPrice.textContent = price;
    }

    if (oldPrice) {
      oldPrice.textContent = comparePrice;
      oldPrice.style.display = comparePrice ? '' : 'none';
    }

    if (button) {
      button.disabled = !available;
      button.setAttribute('aria-disabled', available ? 'false' : 'true');
    }

    if (buttonText) {
      buttonText.textContent = available ? 'Add to Cart' : 'Sold Out';
    }

    if (image && imageUrl) {
      image.src = imageUrl;
      image.removeAttribute('srcset');
    }
  });